
import * as bootstrap from 'bootstrap'
import Utils from '../../../utils'
import DefaultController from "../../defaultController";
import ContractEntity from "../entity";
import ContractShowServices from "./show/services";

export default class ContractShow extends DefaultController {
    async init() {
        this.entity = "contracts";
        await super.init();
        this.childs = {
            services: new ContractShowServices(this),
        }
    }

    protected getEntityData(elem: any) {
        return ContractEntity.getEntityData(elem)
    }
    bindListeners() {
        (document.querySelector("#editContractForm") as HTMLFormElement).addEventListener("submit", async (e) => {
            e.preventDefault();
            const elem = document.querySelector("#editContractForm") as HTMLFormElement;
            const valid = elem.checkValidity();
            if (valid) {
                const r = await Utils.entity.upsert(this.getEntityData(elem), this.entity)
                if (r.status === 200) {
                    await this.getEntity()
                    const bsElem = bootstrap.Modal.getInstance((document.querySelector("#editContract") as HTMLElement));
                    if (bsElem) {
                        bsElem.hide();
                    }
                    this.toastr.success(`${Utils.translate('contract.name')} ${Utils.translate('generic.saved')}`, `${Utils.translate('generic.success')}`)
                }
            }
        });
    }
}